import React from 'react';
import { GradientBorder } from 'components/common/GradientBorder';
import { gradients } from 'theme/tokens';
import type { LevelItem } from 'data/analysisDisplay';

interface KeyLevelsProps {
  resistance: LevelItem[];
  support: LevelItem[];
}

function chunkPairs<T>(arr: T[]): T[][] {
  const result: T[][] = [];
  for (let i = 0; i < arr.length; i += 2) {
    result.push(arr.slice(i, i + 2));
  }
  return result;
}

function LevelCard({ level, kind }: { level: LevelItem; kind: 'res' | 'sup' }) {
  return (
    <GradientBorder
      colors={kind === 'res' ? gradients.borderShort : gradients.borderDefault}
      borderRadius={10}
      borderWidth={2}
      className="level-card"
      innerClassName="level-card-inner"
    >
      <div className="level-tag">{level.label}</div>
      <div className={kind === 'res' ? 'level-value-res' : 'level-value-sup'}>{level.value}</div>
      {level.rangeTo && <div className="level-range-to">{level.rangeTo}</div>}
      {level.note && <div className="level-note">{level.note}</div>}
    </GradientBorder>
  );
}

export function KeyLevels({ resistance, support }: KeyLevelsProps) {
  return (
    <div className="section">
      <div className="section-title">Key Levels</div>

      <div className="level-group-res">↑ Resistance</div>
      {chunkPairs(resistance).map((pair, ri) => (
        <div key={ri} className="level-row">
          {pair.map((l, i) => (
            <LevelCard key={i} level={l} kind="res" />
          ))}
        </div>
      ))}

      <div className="level-group-sup level-group-spacer">↓ Support</div>
      {chunkPairs(support).map((pair, si) => (
        <div key={si} className="level-row">
          {pair.map((l, i) => (
            <LevelCard key={i} level={l} kind="sup" />
          ))}
        </div>
      ))}
    </div>
  );
}
